import produce from 'immer'
import { baseReportUrl } from 'environments'
import { createActions, normalizeDateRange } from 'helpers/actions'
import entityNames from 'options/entityNames'

export default createActions(entityNames.requisitionItemsReport, {
  basePath: 'report/orderReports',
  baseUrl: baseReportUrl,
  transformGetItemsParams: (params = {}) =>
    produce(params, (draft) => {
      draft.locationVendingTypes = ['NonVending']
      draft.approved = draft.approved ?? 'All'

      normalizeDateRange(draft)
    }),
})
